import { render, staticRenderFns } from "./topmenu.vue?vue&type=template&id=1f2d5a12&scoped=true&"
import script from "./topmenu.vue?vue&type=script&lang=js&"
export * from "./topmenu.vue?vue&type=script&lang=js&"
import style0 from "./topmenu.vue?vue&type=style&index=0&id=1f2d5a12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d5a12",
  null
  
)

export default component.exports